import { interstateInputEventBuilder } from '../../InterstateEvents';
import { MenuItem } from './MenuItem';
import { nanoid } from 'nanoid';
import { idBuilder } from '../../internal';
import { Box } from '../../Box';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const MenuItems = props => {
  const {
    size,
    id,
    menuOptions,
    onClose,
    icon,
    onSelect,
    ...rest
  } = props;
  const _menu = menuOptions?.map((option, index) => {
    const handleOnClick = (menuOnSelect, optionSelection) => () => {
      if (optionSelection) {
        optionSelection(interstateInputEventBuilder(undefined, option.value, undefined, undefined, option.label, undefined));
      } else if (menuOnSelect) {
        menuOnSelect(interstateInputEventBuilder(undefined, option.value, undefined, undefined, option.label, undefined));
      }
      onClose?.();
    };
    return /*#__PURE__*/_jsxs(MenuItem, {
      disabled: option.disabled,
      id: idBuilder('ids-menu-item', id, index),
      "data-testid": idBuilder('ids-menu-item', rest['data-testid'], index),
      divider: option.divider,
      onClick: option.disabled ? undefined : handleOnClick(option.onSelect, onSelect),
      label: option.label || nanoid(),
      size: size,
      children: [icon && /*#__PURE__*/_jsx(Box, {
        display: "flex",
        fontSize: '20px',
        children: icon
      }), option.label]
    }, option.value);
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: _menu
  });
};